module.exports = __webpack_public_path__ + "static/media/hospital.d98426ca.svg";